import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { LigacaoTelemarketing } from '../models/ligacao-telemarketing';

@Injectable({
  providedIn: 'root'
})
export class LigacaoService {

  constructor(private http: HttpClient) { }

  consultarComPaginacao(descri: string, idIntegrador, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descri.length > 0) {
      parametros = parametros.set('descri', descri);
    }

    if (idIntegrador) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Ligacao/ListaPag',
      {
        params: parametros
      });
  }

  consultarLista(idIntegrador) {
    let parametros = new HttpParams();

    if (idIntegrador) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Ligacao/Lista',
      {
        params: parametros
      });
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/Ligacao/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  salvar(vm: LigacaoTelemarketing) {
    return this.http.post(globals.apiUrl + '/api/Ligacao/Salvar', vm);
  }

  excluir(id: number) {
    return this.http.delete(globals.apiUrl + '/api/Ligacao/Excluir',
      { params: new HttpParams().set('id', id.toString()) });
  }
}
